import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { durationConverter } from 'utils/duration';
import { WaitModal } from '../../modals/wait';
const translatePayload = (node) => {
    const { nonMatchNodeId, matchNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'Trigger false',
            connection: nonMatchNodeId || uuid(),
        },
        {
            id: uuid(),
            label: 'Trigger still true',
            connection: matchNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const key = connection.connectionLabel === 'Trigger still true'
        ? 'matchNodeId'
        : 'nonMatchNodeId';
    const payload = Object.assign(Object.assign({}, node.payload), { [key]: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const WaitNodeAttributes = {
    iconName: 'calendar',
    label: 'Wait',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: WaitNode,
    ActionModal: WaitModal,
};
export function WaitNode({ node }) {
    const { payload } = node;
    const { delayInSeconds } = payload;
    const waitTimeString = durationConverter.toString(delayInSeconds);
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: waitTimeString }) })), [waitTimeString]) }));
}
